import { render, staticRenderFns } from "./StatisticsList.vue?vue&type=template&id=38d6f31c"
import script from "./StatisticsList.vue?vue&type=script&lang=js"
export * from "./StatisticsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports